import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';

/**
 * Compact transition into PrototypeProof — offer framing + named operator proof.
 */
export function Solution() {
  return <section className="bg-navy px-6 py-14 text-paper md:px-10 md:py-20" data-id="element-1064" data-mp="lkas83pmuzk7">
      <div className="mx-auto max-w-3xl" data-id="element-1065" data-mp="gkxxyxwfmq7l">
        <Reveal data-id="element-1066" data-mp="gk6akacznyse">
          <Eyebrow data-id="element-1067" data-mp="gjmqamzv8yb7">The Reader-to-Revenue Build</Eyebrow>
          <h2 className="mt-3 font-serif text-3xl leading-[1.08] text-paper md:text-4xl" data-id="element-1068" data-mp="vhozbcpo2bzu">
            We build what comes next.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-paper/70 md:text-lg" data-id="element-1069" data-mp="qivhx979e0ue">
            Author Leverage takes the ideas, frameworks, stories, language, and
            offers already inside your book and builds one connected
            Reader-to-Revenue System around them.
          </p>
          <p className="mt-6 font-serif text-xl leading-snug text-seaglass-light md:text-2xl" data-id="element-1070" data-mp="1e9815g7yfk0a">
            One done-for-you service.
          </p>
          <div className="mt-4 space-y-2 text-base leading-relaxed text-paper/80 md:text-lg" data-id="element-1071" data-mp="2pedzx31j0x18">
            <p data-id="element-1072" data-mp="2ucz0j3koxiq7">The reader experience is the mechanism.</p>
            <p data-id="element-1073" data-mp="2udh6wt12hdbu">Author leverage is the outcome.</p>
            <p data-id="element-1074" data-mp="2zbsh54v9xpul">
              The path, the offers, and the follow-up make that leverage
              commercially useful.
            </p>
          </div>

          <div className="mt-10 border-t border-white/15 pt-8" data-id="element-1075" data-mp="33bst8iuwhoyh">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:gap-7" data-id="element-1076" data-mp="38byrwizl8bq2">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/44613e2b-90fb-4116-b3c8-797cf4f5a5ea/john-westley.webp" alt="John Westley, Founder of Author Leverage" width={112} height={112} className="h-24 w-24 flex-shrink-0 rounded-full object-cover object-top ring-2 ring-seaglass/40 sm:h-28 sm:w-28" data-id="element-1077" data-mp="3dbb9opblqsls" />
              <div className="min-w-0" data-id="element-1078" data-mp="3r1n5ay7eb9ho">
                <p className="font-serif text-xl leading-snug text-seaglass-light md:text-2xl" data-id="element-1079" data-mp="3w1syiitbd41v">
                  Led by John Westley.
                </p>
                <p className="mt-1 text-sm text-paper/55" data-id="element-1080" data-mp="1vxyud6nz7kll">
                  Founder, Author Leverage
                  <span className="mx-2 text-paper/30" aria-hidden="true" data-id="element-1081" data-mp="1rwwwou9pjglq">
                    ·
                  </span>
                  <a href="https://www.linkedin.com/in/johnwestley/" target="_blank" rel="noopener noreferrer" className="text-paper/70 underline decoration-paper/25 underline-offset-2 transition-colors hover:text-seaglass-light hover:decoration-seaglass-light/50" data-id="element-1082" data-mp="20ywcxkcwegnm">
                    LinkedIn
                  </a>
                </p>
                <p className="mt-4 text-base leading-relaxed text-paper/80 md:text-lg" data-id="element-1083" data-mp="2onp99hxfmqir">
                  Across leadership roles in thought-leadership businesses —
                  coaching, training, events, and author-led companies — I’ve
                  worked inside organizations whose annual revenue totaled more
                  than $500 million during that time. That includes helping
                  scale Tom Ferry from roughly $6M to $84M, and serving as
                  President of Jon Gordon Companies.
                </p>
                <p className="mt-4 text-base leading-relaxed text-paper/80 md:text-lg" data-id="element-1084" data-mp="2s6whr4811ztl">
                  I stay close on strategy and judgment. A specialist team
                  handles the design, build, and delivery — so your account has
                  real capacity behind it, and the work does not bottleneck on
                  one person.
                </p>
                <p className="mt-4 text-base leading-relaxed text-paper/80 md:text-lg" data-id="element-1085" data-mp="2n5qnv32ms6ih">
                  Author Leverage exists because I already know how this world
                  works. The gap isn’t usually another idea. It’s the path after
                  the book.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}